import React from 'react';

const Footer = () => {

    return(
        <div className="mobile-footer">
        <div className='copyright'>
            <span> Copyright &copy; SheCanCode 2020 </span>
        </div>
      </div>
    )
}

export default Footer;
